import { render, staticRenderFns } from "./AgTableServerSide.vue?vue&type=template&id=0336bf67&"
import script from "./AgTableServerSide.vue?vue&type=script&lang=js&"
export * from "./AgTableServerSide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports